// src/App.tsx
import { BrowserRouter, HashRouter, Routes, Route, useNavigate } from 'react-router-dom';
import { BottomNav } from './components/BottomNav';
import { HomeScreen } from './screens/HomeScreen';
import { SportScreen } from './screens/SportScreen';
import { ParlayScreen } from './screens/ParlayScreen';
import { TrackerScreen } from './screens/TrackerScreen';
import { Navigate } from 'react-router-dom';
import { ScheduleScreen } from './screens/ScheduleScreen';
import { AccountScreen } from './screens/AccountScreen';
import { Sport } from './domain/types';
import { useParlayStore } from './stores/parlayStore';
import { FiArrowRight } from 'react-icons/fi';
import './styles/globals.css';

function App() {
  const Router = window.location.protocol === 'file:' ? HashRouter : BrowserRouter;

  return (
    <Router><AppFrame /></Router>
  );
}

function AppFrame() {
  const { legs } = useParlayStore();
  const navigate = useNavigate();
  return <div className="app-shell">
    <Routes>
      <Route path="/" element={<HomeScreen />} />
      <Route path="/nba" element={<SportScreen sport={Sport.NBA} />} />
      <Route path="/nhl" element={<SportScreen sport={Sport.NHL} />} />
      <Route path="/schedule/:sport" element={<ScheduleScreen />} />
      <Route path="/parlay" element={<ParlayScreen />} />
      <Route path="/tracker" element={<TrackerScreen />} />
      <Route path="/bankroll" element={<Navigate to="/tracker" replace />} />
      <Route path="/profile" element={<AccountScreen />} />
      <Route path="*" element={<HomeScreen />} />
    </Routes>
    {legs.length > 0 && <button className="parlay-dock" onClick={() => navigate('/parlay')}>
      <span><b>{legs.length}</b> seleção{legs.length > 1 ? 'ões' : ''} no construtor</span><strong>VER PARLAY <FiArrowRight /></strong>
    </button>}
    <BottomNav />
  </div>;
}

export default App;
